import { registerSW } from "virtual:pwa-register";

export function setupPwa() {
  registerSW({
    immediate: false,
    onNeedRefresh() {
      const accept = window.confirm("A new app version is ready. Reload now? Unsaved edits will be lost.");
      if (accept) window.location.reload();
    },
  });
}
